import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { usePeriod } from '@/context/PeriodContext';

export function usePeriodSummary() {
  const { year, month } = usePeriod();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const p = await api.get(`/periods/lookup/${year}/${month}`);
        const s = await api.get(`/periods/${p.data.id}/summary`);
        if (!cancelled) setData(s.data);
      } catch (e) {
        if (!cancelled) setData(null);
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [year, month, refreshKey]);

  return { data, loading, refresh: () => setRefreshKey(k => k + 1) };
}
